import { notNil } from 'util/null'
import { loadJson, saveJson } from 'util/storage'

export type ClientRequest = {
  company: string
  phone?: string
  email?: string
  card?: string
}

export type ClientSuggestRequest = {
  company: string
  phone?: string
  email?: string
  card?: string
}

export type ClientCheckRequest = {
  company: string
  phone?: string
  email?: string
  card?: string
}

export type Client = {
  user_id: string
  name?: string
  phone?: string
  email?: string
  card?: string
  picture?: string
  personal_data_consent: number
}

export type Customer = Client & {
  company: string
}

export type UserUpdateRequest = {
  user_id: string
  name?: string
  phone?: string
  picture?: string
  card?: string
  personal_data_consent?: number
}

export function loadClient(manager_id: string): Customer | undefined {
  return loadJson('boutique.client.' + manager_id)
}

export function saveClient(manager_id: string, customer: Customer | undefined): void {
  if (customer) addRecentCustomer(manager_id, customer)
  saveJson('boutique.client.' + manager_id, customer)
}

function loadCustomer(user_id: string): Customer | undefined {
  return loadJson('boutique.customer.' + user_id)
}

function saveCustomer(customer: Customer): void {
  const { user_id } = customer
  saveJson('boutique.customer.' + user_id, customer)
}

export function loadRecentCustomers(company: string, manager_id: string | undefined): Customer[] {
  if (!company || !manager_id) return []
  const ids = loadRecentCustomerIds(company, manager_id)
  return ids.map(loadCustomer).filter(notNil)
}

function buildRecentKey(company: string, manager_id: string) {
  return `boutique.company.${company}.manager.${manager_id}.customers`
}

function loadRecentCustomerIds(company: string, manager_id: string): string[] {
  const key = buildRecentKey(company, manager_id)
  return loadJson(key) || []
}

export function addRecentCustomer(manager_id: string, customer: Customer): void {
  const { company, user_id } = customer
  let ids = loadRecentCustomerIds(company, manager_id)
  ids = ids.filter(it => it !== user_id)
  ids.unshift(user_id)
  if (ids.length > 10) ids.length = 10
  const key = buildRecentKey(company, manager_id)
  saveJson(key, ids)
  saveCustomer(customer)
}
